import { call, put, takeLatest } from "redux-saga/effects";
import {
  BOLApiTokenInit,
  BOLApiTokenSuccess,
  BOLApiTokenFailure,
} from "./BOLApiTokenSlice";
import { _CALLPOSTAPI } from "../../api/apiHandler";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, SUCCESS } from "../../constants/AppConstants";
import { getLocalSessionData, setLocalSessionData } from "../../utils/Authentication/handleUserSession";
import i18next from "i18next";

function __APIHANDLER(email) {
    const endpoint = _API_ENDPOINT.BOL.ISSUE_TOKEN;
    const ADB2CID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
    const countryCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE);
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);

    const formattedUserID = () => {
      if (UID === 'null' || !UID || UID === "" || UID === "undefined") {
        return "";
      }
      const upperUID = `{${UID?.toUpperCase()}}`;
      return encodeURIComponent(upperUID);
    }

    const payload = {
      "adb2cId": ADB2CID,
      "bolAccountEmail": email,
      "bocUserId": formattedUserID(),
      "countryCode": countryCode
    }

    return _CALLPOSTAPI(endpoint, payload)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
}


function* handleCreateBOLApiToken(action) {
  try {
    const  {email} = action.payload || {};
    const response = yield call(__APIHANDLER, email);
    if(response.actionStatus.toUpperCase() === SUCCESS){
        if(response.bocUserId){
          const constructTokenString = `token=${response.token}&token_type=${response.tokenType}&expires_in=${response.expiresIn}&state=state`;
          setLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO, JSON.stringify(constructTokenString));
          yield put(BOLApiTokenSuccess(response));
        } else {
          yield put(BOLApiTokenSuccess({
            ...response, 
            ...{'is_retry': true}
          }));
        }
    } else {
        yield put(BOLApiTokenFailure(i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")));
    }
  } catch (error) {
    yield put(BOLApiTokenFailure(error.message));
  }
}

export default function* watchBOLApiToken() {
  yield takeLatest(BOLApiTokenInit.type, handleCreateBOLApiToken);
}
